import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  Inject,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { LangService } from 'src/app/services/lang.service';
import { Lang } from 'src/app/models/lang';
import { Strings } from '../../const/strings';
import { TrackingService } from 'src/app/services/tracking.service';

type SubMenuTypes = 'about' | 'option' | 'content';

@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderNavComponent implements OnInit, OnDestroy {

  appUrl: string;
  lang: Lang;
  strings = Strings;

  @Input() isOpen: boolean;
  @Output() clickMenuButton = new EventEmitter();

  isAboutSubMenuOpened = false;
  isOptionSubMenuOpened = false;
  isContentSubMenuOpened = false;
  private documentClickListener = null;
  private keepAboutSubMenuListener = null;
  private keepOptionSubMenuListener = null;
  private keepContentSubMenuListener = null;

  @ViewChild('aboutMenuParent') aboutMenuParentElement: ElementRef;
  @ViewChild('optionMenuParent') optionMenuParentElement: ElementRef;
  @ViewChild('contentsMenuParent') contentsMenuParentElement: ElementRef;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private changeDetectorRef: ChangeDetectorRef,
    private langService: LangService,
    private googleAnalyticsService: TrackingService,
  ) { }

  ngOnInit() {
    this.appUrl = this.langService.getAppUrl();
    this.lang = this.langService.getCurrentLang();
  }

  ngOnDestroy() {
    this.removeDocumentClickEvent();
  }

  tapMenu() {
    this.clickMenuButton.emit();
  }

  toggleSubMenu(type: SubMenuTypes) {
    switch (type) {
      case 'about':
        this.isAboutSubMenuOpened = !this.isAboutSubMenuOpened;
        this.isOptionSubMenuOpened = false;
        this.isContentSubMenuOpened = false;
        this.clickAboutButton();
        break;
      case 'option':
        this.isOptionSubMenuOpened = !this.isOptionSubMenuOpened;
        this.isAboutSubMenuOpened = false;
        this.isContentSubMenuOpened = false;
        this.clickOptionButton();
        break;
      case 'content':
        this.isContentSubMenuOpened = !this.isContentSubMenuOpened;
        this.isAboutSubMenuOpened = false;
        this.isOptionSubMenuOpened = false;
        this.clickContentsButton();
        break;
    }
  }

  sendAdsTelEvent(event: Event) {
    event.preventDefault();
    const url = 'tel:' + this.strings.carDetail.supportTelNumber[this.lang];
    this.googleAnalyticsService.sendAdsTelEvent(url);
  }

  private clickAboutButton() {
    this.documentClickListener = this.closeSubMenu.bind(this);
    this.keepAboutSubMenuListener = this.keepSubMenu.bind(this);
    this.document.addEventListener('click', this.documentClickListener, false);
    this.aboutMenuParentElement.nativeElement.addEventListener('click', this.keepAboutSubMenuListener, false);
  }

  private clickOptionButton() {
    this.documentClickListener = this.closeSubMenu.bind(this);
    this.keepOptionSubMenuListener = this.keepSubMenu.bind(this);
    this.document.addEventListener('click', this.documentClickListener, false);
    this.optionMenuParentElement.nativeElement.addEventListener('click', this.keepOptionSubMenuListener, false);
  }

  private clickContentsButton() {
    this.documentClickListener = this.closeSubMenu.bind(this);
    this.keepContentSubMenuListener = this.keepSubMenu.bind(this);
    this.document.addEventListener('click', this.documentClickListener, false);
    this.contentsMenuParentElement.nativeElement.addEventListener('click', this.keepContentSubMenuListener, false);
  }

  private removeDocumentClickEvent() {
    this.document.removeEventListener('click', this.documentClickListener);
    if (this.keepAboutSubMenuListener) {
      this.isAboutSubMenuOpened = false;
      this.aboutMenuParentElement.nativeElement.removeEventListener('click', this.keepAboutSubMenuListener);
    }
    if (this.keepOptionSubMenuListener) {
      this.isOptionSubMenuOpened = false;
      this.optionMenuParentElement.nativeElement.removeEventListener('click', this.keepOptionSubMenuListener);
    }
    if (this.keepContentSubMenuListener) {
      this.isContentSubMenuOpened = false;
      this.contentsMenuParentElement.nativeElement.removeEventListener('click', this.keepContentSubMenuListener);
    }
    // 強制的に再描画させる
    this.changeDetectorRef.detectChanges();
  }

  private closeSubMenu() {
    this.removeDocumentClickEvent();
  }

  private keepSubMenu(e) {
    e.stopPropagation();
  }

}
